import type { AxiosInstance } from "axios"

import { snakeCaseToCamelCase } from "./formatters"
import i18next from "./i18n"

const allowPassThrough = [
  "api/v1/feature-flags",
  "api/v1/site_explorer",
  "recommendations/interventions",
  "recommendations/locations",
  // E2 temporal-drill leaf: BE + FE contract (TemporalDrillResponse) is
  // snake_case verbatim (period_key, waste_dollars, dollars_per_hr, ...) and
  // is consumed directly by RecurrenceHeatmap/DriverBars/TimeslotAttribution
  // viz built for the snake_case master ScheduleMisalignmentDetail shape.
  // Scoped to this one leaf path only — does NOT match
  // "neat/insights/variance/..." (the disaggregation leaf), which relies on
  // camelCasing via this same interceptor for its DisaggregationLeaf type.
  "api/v1/neat/insights/schedule-misalignment",
]

// Includes `/intervals/export` file bodies so they are not camelCased.
const CORE_API_RESOURCE_PATHS = [
  "/bill-periods",
  "/bills",
  "/intervals",
] as const

const isCoreApiResponse = (url: string | undefined): boolean =>
  Boolean(
    url?.includes("organizations/") &&
    CORE_API_RESOURCE_PATHS.some((path) => url.includes(path))
  )

export const initCaseResponseInterceptor = (httpClient: AxiosInstance) =>
  httpClient.interceptors.response.use((response) => {
    if (
      isCoreApiResponse(response.config.url) ||
      allowPassThrough.some(
        (passThroughUrl) =>
          response.config.url?.includes(passThroughUrl) ?? false
      )
    ) {
      return response
    }
    return {
      ...response,
      data: snakeCaseToCamelCase(response.data as unknown),
    }
  })

export const initLanguageRequestInterceptor = (httpClient: AxiosInstance) =>
  httpClient.interceptors.request.use((config) => {
    config.headers["X-User-Language"] = i18next.language
    return config
  })
